<template>
    <div class="videoMain">
        <video id="vid" playsinline autoplay loop muted>
            <source src="../../assets/video/index.mp4" type="video/mp4">
        </video>
    </div>
</template>

<script>
export default {
    name: 'VideoFullScreen'
}
</script>

<style scoped>
  .videoMain {
    position: relative;
    width: 100%;
    height: 100vh;
    background-color: black;
  }

  .videoMain > video{
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
  

</style>